import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteACourseRequest,
  getCourseRequests,
  resetState,
  updateACourseRequest,
  markCourseRequestAsRead,
} from "../features/courseRequests/courseRequestSlice"; // Actions for course requests
import { AiFillDelete, AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile",
    dataIndex: "mobile",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const CourseRequests = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [requestId, setRequestId] = useState("");

  const showModal = (id) => {
    setOpen(true);
    setRequestId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(resetState());
    dispatch(getCourseRequests()); // Fetch course requests
  }, [dispatch]);

  const courseRequestState = useSelector((state) => state.courseRequests.courseRequests);
 console.log(courseRequestState,"COURSE")
 const handleViewRequestClick = (requestId) => {
  dispatch(markCourseRequestAsRead(requestId));
};


  const generateData = (requests) =>
    requests.map((request, index) => ({
      key: index + 1,
      name: request.name,
      email: request.email,
      mobile: request.phone,
      status: (
        <select
          defaultValue={request.status ? request.status : "Submitted"}
          className="form-control form-select"
          onChange={(e) => setRequestStatus(e.target.value, request._id)}
        >
          <option value="Submitted">Submitted</option>
          <option value="Contacted">Contacted</option>
        </select>
      ),
      action: (
        <>
          <Link
            className={`ms-3 fs-3 ${request.read ? "text-secondary" : "text-primary"}`}
            to={`/admin/course-requests/${request._id}`}
            onClick={() => handleViewRequestClick(request._id)}
          >
            <AiOutlineEye />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(request._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
      className: request.read ? "read-row" : "unviewed-row", // Apply class to differentiate by read/unread
    }));

  const setRequestStatus = (status, id) => {
    dispatch(updateACourseRequest({ id, status })); // Update course request status
  };

  const deleteRequest = (id) => {
    dispatch(deleteACourseRequest(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getCourseRequests()); // Re-fetch course requests after deletion
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Course Requests</h3>

      <Table
        columns={columns}
        dataSource={generateData(courseRequestState)} // Use all course requests in a single table
        rowClassName={(record) => record.className} // Apply row class based on read/unread status
      />

      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteRequest(requestId)}
        title="Are you sure you want to delete this course request?"
      />
    </div>
  );
};

export default CourseRequests;
